import { getInput, getNodeList } from '~/js/utils/selectors';

function appendSpanStylesToCheckboxAndRadioButtons() {
  const weFormsCheckboxLabels = getNodeList<HTMLLabelElement>(
    '.wpuf-checkbox-block, .wpuf-radio-block'
  );
  if (!weFormsCheckboxLabels.length) return;
  weFormsCheckboxLabels.forEach((label) => {
    const input = getInput('input', label);

    input.insertAdjacentHTML('afterend', '<span class="input-box"></span>');
  });
}

export default appendSpanStylesToCheckboxAndRadioButtons;
